import Button from '@components/atoms/button'
import { FastlyImage } from '@components/common/image'

const AboutUsCard = () => {
  return (
    <div className="relative overflow-hidden px-5 py-12 lg:py-16">
      <div className="container mx-auto px-4">
        {/* Main Heading */}
        <h2 className="max-w-4xl mx-auto pb-3 text-2xl text-center text-grey lg:text-4xl font-600 leading-tight">
          About Codingal
        </h2>

        {/* Content Grid */}
        <div className="flex flex-col lg:flex-row gap-8 items-center lg:items-stretch mt-8">
          {/* Left Column - Text Content */}
          <div className="flex flex-col items-center lg:items-stretch flex-1">
            <p className="text-base lg:text-lg mb-2 text-center lg:text-left">
              Codingal is a fast-growing edtech company on a mission to help
              kids fall in love with coding and AI through live classes and
              hands-on projects. What makes this journey special is our people:
              teachers, builders, and problem-solvers who genuinely care about
              learning.
              <br />
              We work as one team across curriculum, engineering, design,
              growth, operations, and support, always improving how we teach,
              how we train teachers, and how students learn. If you are a
              teacher who loves mentoring, or a parent looking for a learning
              experience that is personal, structured, and future-ready,
              welcome.
            </p>

            {/* CTA Button */}
            <div className="mt-5 w-full sm:w-auto">
              <a
                className="underline"
                href="/about-us"
                target="_blank"
                rel="noreferrer"
              >
                <Button
                  size="md"
                  variant="outline"
                  className="w-full sm:w-auto"
                >
                  Discover Our Mission
                </Button>
              </a>
            </div>
          </div>

          {/* Right Column - Illustration */}
          <div className="relative flex items-center justify-center flex-1">
            <FastlyImage
              src="/images/reviews-and-testimonials/about-codingal.jpg"
              alt="Codingal team"
              height={359}
              width={517}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutUsCard
